import RoomTypeTranslationGenerated, { RoomTypeTranslationGeneratedEntityManager } from './generated/RoomTypeTranslation.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';


export class RoomTypeTranslationEntityManager extends RoomTypeTranslationGeneratedEntityManager<RoomTypeTranslation>
{
    constructor()
    {
        super({
            createEntity: () => new RoomTypeTranslation(),
        });
    }
}


/**
 * RoomTypeTranslation
 * 
 * Read this document on how to work with TypeScript business entities: .cursor/rules/xapp-ts-business-entity-rules.mdc
 */
export class RoomTypeTranslation extends RoomTypeTranslationGenerated
{
    static _manager: RoomTypeTranslationEntityManager;
    static get manager(): RoomTypeTranslationEntityManager
    {
        if (!this._manager) this._manager = new RoomTypeTranslationEntityManager();
        return this._manager;
    }
}


export default RoomTypeTranslation;